export enum TimezoneId {
  AMERICA_ANCHORAGE = 'America/Anchorage',
  AMERICA_LOS_ANGELES = 'America/Los_Angeles',
  AMERICA_ADAK = 'America/Adak',
  AMERICA_METLAKATLA = 'America/Metlakatla',
  AMERICA_CHICAGO = 'America/Chicago',
  AMERICA_PHOENIX = 'America/Phoenix',
  AMERICA_DENVER = 'America/Denver',
  AMERICA_NEW_YORK = 'America/New_York',
  PACIFIC_HONOLULU = 'Pacific/Honolulu',
  AMERICA_PUERTO_RICO = 'America/Puerto_Rico'
}
